var _defs, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnimalCachorroDogSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    id: "ART",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#915a31;}.cls-1,.cls-2,.cls-4,.cls-5,.cls-6{stroke:#000;stroke-miterlimit:10;}.cls-1,.cls-2{stroke-width:4px;}.cls-2{fill:#a06538;}.cls-3{fill:#d6d6d6;}.cls-4{fill:#333;}.cls-4,.cls-5,.cls-6{stroke-width:2px;}.cls-5{fill:none;}.cls-6{fill:#fff;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.41,87.3c2.12,2.75,3.38,14.05-4.72,14.05-6.54,0-22.6-6.84-22.6-20.37s-18-51.44-18-51.44c22.45,0,43.66.88,43.66,28.83C141.76,58.37,141.29,84.55,143.41,87.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.59,87.3c-2.12,2.75-3.38,14.05,4.72,14.05,6.54,0,22.6-6.84,22.6-20.37s18-51.44,18-51.44c-22.45,0-43.66.88-43.66,28.83C8.24,58.37,8.71,84.55,6.59,87.3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.27,73.22c0,47.32-16.91,61.52-44.27,61.52s-44.27-14.2-44.27-61.52,24.77-58,44.27-58S119.27,25.9,119.27,73.22Z",
    "data-name": "<Path>",
    id: "_Path_"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104.69,121.79c-6.7,7.46-16.2,11-29.69,11s-23-3.49-29.69-11c2.94-12.49,8-26.67,14.06-35.75C67,74.6,69.49,38.94,67.62,17.82a48.91,48.91,0,0,1,14.76,0C80.51,38.94,83,74.6,90.63,86,96.69,95.12,101.75,109.3,104.69,121.79Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75.77,119.33c-3.18,0-15.65-16.29-14.62-18.84s5.21-5,14.62-5,13.59,2.42,14.64,5S79,119.33,75.77,119.33Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M82.41,122.37c-.47,4.17-4.25,6-7.14,6s-6.67-1.84-7.13-6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 53.02,
    cy: 75,
    r: 10.57
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 96.98,
    cy: 75,
    r: 10.57
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.34,
    cy: 75,
    r: 5.92
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.66,
    cy: 75,
    r: 5.92
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimalCachorroDogSvgrepoCom);
export default __webpack_public_path__ + "static/media/animal-cachorro-dog-svgrepo-com.7dac5e74b7eab6b13ea164fbac1c2f03.svg";
export { ForwardRef as ReactComponent };